import { BaseApiClient } from '../BaseApiClient'

export default class ApplicationClient extends BaseApiClient {
  static async applicationList (params) {
    return this.get('application/list', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async statuses () {
    return await this.get('application/statuses', {
      headers: this.getAuthHeaders()
    }).then(response => response.data.data)
  }

  static async portCost () {
    return await this.get('application/port-cost', {
      headers: this.getAuthHeaders()
    }).then(response => response.data.data)
  }

  static async filters () {
    return await this.get('application/filters', {
      headers: this.getAuthHeaders()
    }).then(response => response.data.data)
  }

  static async editApplication (data) {
    return this.post('application/edit', data, {
      headers: this.getAuthHeaders()
    })
  }
}
